import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-container',
    templateUrl: './container.component.html',
    styleUrls: ['./container.component.scss'],
    standalone: false
})
export class ContainerComponent implements OnInit {

  @Input()
  shippingContainer: any;

  constructor() {
  }

  eta: string | null = null;

  ngOnInit(): void {
    const events = this.shippingContainer?.sourceEvents || [];
    const lastPlanned = [...events].reverse().find(
      (e: any) => e.eventClassifierCode === 'PLN' || e.eventClassifierCode === 'EST'
    );
    this.eta = lastPlanned?.eventDateTime || null;
  }
}
